<template>
    <div class="min-h-screen bg-gray-50">
    <div class="max-w-8xl mx-auto py-8 px-4">
      <!-- 顶部筛选区域 -->
      <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
        <div class="flex justify-between items-center">
          <div class="flex items-center gap-4">
            <!-- 供应商下拉选择 -->
            <div class="relative" v-if="isuse == 1">
              <button @click="toggleSupplierDropdown" class="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700 hover:bg-gray-50">
                <i class="fas fa-building"></i>
                <span class="whitespace-nowrap">{{ selectedSupplier.name || '选择供应商' }}</span>
                <i class="fas fa-chevron-down text-gray-400"></i>
              </button>
              <div v-if="showSupplierDropdown" class="absolute z-10 w-56 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                <div class="py-2">
                  <div v-for="item in supply" :key="item.supply_id" @click="selectSupplier(item)" class="px-4 py-2 hover:bg-gray-50 cursor-pointer">
                     {{item.name}}
                  </div>
                </div>
              </div>
            </div>
            
            <!-- 日期范围选择 -->
            <div class="flex items-center gap-2">
              <input type="date" v-model="form.startDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
              <span class="text-gray-500">至</span>
              <input type="date" v-model="form.endDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
            </div>
          </div>

        
        <button  @click="search" class="px-6 py-2 bg-blue-600 text-white rounded-button hover:bg-blue-700 flex items-center gap-2">
             
                <span class="whitespace-nowrap">查询</span>
          </button>
          

        </div>
      </div>
  
      <!-- 数据统计卡片 -->
      <div class="grid grid-cols-4 gap-6 mb-6">
        <div v-for="(stat, index) in statistics" :key="index" class="bg-white rounded-lg shadow-sm p-6">
          <div class="flex items-start justify-between">
            <div>
              <p class="text-gray-500 mb-2">{{ stat.title }}</p>
              <h3 class="text-2xl font-semibold">{{ stat.value }}</h3>
            </div>
            <!-- <div :class="`w-10 h-10 rounded-full flex items-center justify-center ${stat.iconBg}`">
              <i :class="`${stat.icon} text-white`"></i>
            </div> -->
          </div>
          <div class="mt-4 flex items-center" :class="stat.trend >= 0 ? 'text-green-500' : 'text-red-500'">
            <i :class="`fas ${stat.trend >= 0 ? 'fa-arrow-up' : 'fa-arrow-down'} mr-1`"></i>
            <span>{{ Math.abs(stat.trend) }}%</span>
            <span class="text-gray-500 ml-2">环比上月</span>
          </div>
        </div>
      </div>
  
      <!-- 图表区域 -->
      <div class="grid grid-cols-2 gap-6 mb-6">
        <!-- 柱状图 -->
        <div class="bg-white rounded-lg shadow-sm p-6">
          <h3 class="text-lg font-medium mb-4">人员月度统计趋势</h3>
          <div ref="barChart" class="w-full h-80"></div>
        </div>
        
        <!-- 饼图 -->
        <div class="bg-white rounded-lg shadow-sm p-6">
          <h3 class="text-lg font-medium mb-4">人员类型分布</h3>
          <div ref="pieChart" class="w-full h-80"></div>
        </div>
      </div>
  
      <!-- 排行榜 -->
      <div class="grid grid-cols-2 gap-6 mb-6">
        <!-- 采购商排行榜 -->
        <div class="bg-white rounded-lg shadow-sm p-6">
          <h3 class="text-lg font-medium mb-4">采购商进货排行榜<button @click="exportToExcel(1)"  style="float: right;"
            class="text-blue-600 hover:text-blue-700 flex items-center !rounded-button whitespace-nowrap">
            <i class="fas fa-download mr-1"></i>
            导出
            </button>
            <div style="clear: both;"></div></h3>
          <div class="space-y-4">
            <div v-for="(item, index) in purchaseRanking" :key="index" class="flex items-center">
              <div class="w-6 h-6 rounded-full flex items-center justify-center" :class="index < 3 ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-500'">
                {{ index + 1 }}
              </div>
              <span class="ml-3 text-gray-900 flex-1">{{ item.name }}</span>
              <div class="flex items-center">
                <span class="text-gray-900 font-medium">¥ {{ item.amount.toLocaleString() }}</span>
                <div class="ml-4 w-20 h-2 bg-gray-100 rounded-full">
                  <div class="h-full bg-blue-500 rounded-full" :style="`width: ${item.percentage}%`"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 业务员排行榜 -->
        <div class="bg-white rounded-lg shadow-sm p-6">
          <h3 class="text-lg font-medium mb-4">业务员邀请人排行榜<button @click="exportToExcel(2)"  style="float: right;"
            class="text-blue-600 hover:text-blue-700 flex items-center !rounded-button whitespace-nowrap">
            <i class="fas fa-download mr-1"></i>
            导出
            </button>
            <div style="clear: both;"></div></h3>
          <div class="space-y-4">
            <div v-for="(item, index) in salesRanking" :key="index" class="flex items-center">
              <div class="w-6 h-6 rounded-full flex items-center justify-center" :class="index < 3 ? 'bg-purple-500 text-white' : 'bg-gray-100 text-gray-500'">
                {{ index + 1 }}
              </div>
              <span class="ml-3 text-gray-900 flex-1">{{ item.name }}</span>
              <div class="flex items-center">
                <span class="text-gray-900 font-medium">{{ item.invites }} 人</span>
                <div class="ml-4 w-20 h-2 bg-gray-100 rounded-full">
                  <div class="h-full bg-purple-500 rounded-full" :style="`width: ${item.percentage}%`"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
    </div>
    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  import Warehouse_managementApi from '@/api/warehouse_management.js';

  import StatisticsApi from '@/api/statistics.js';
  export default {
    data() {
      return {
        selectedSupplier: {'name':""},
        showSupplierDropdown: false,
        startDate: '',
        endDate: '',
        suppliers: ['华为科技', '阿里巴巴', '腾讯科技', '字节跳动', '美团科技'],
        purchaseRanking: [
        ],
        salesRanking: [
        ],
        statistics: [
        ],
        tableData: [
          { name: '赵明辉', type: '采购商', typeClass: 'bg-blue-100 text-blue-800', supplier: '华为科技', date: '2023-12-15' },
          { name: '林志远', type: '司机', typeClass: 'bg-green-100 text-green-800', supplier: '阿里巴巴', date: '2023-12-14' },
          { name: '陈思琪', type: '业务员', typeClass: 'bg-purple-100 text-purple-800', supplier: '腾讯科技', date: '2023-12-13' },
          { name: '王建国', type: '采购商', typeClass: 'bg-blue-100 text-blue-800', supplier: '字节跳动', date: '2023-12-12' },
          { name: '张雨晨', type: '司机', typeClass: 'bg-green-100 text-green-800', supplier: '美团科技', date: '2023-12-11' }
        ],
        currentPage: 1,
        totalPages: 10,
        totalItems: 126,


        supply:[],
        form:{

        },
        isuse:0,
        showSupplierDropdown:false,
      };
    },
    mounted() {
      this.search();
    },
    created() {
          /*获取数据*/
      var self = this;
      self.getInas({},function(res){
        self.isuse = res
      })
      self.getSupplys()
  
    self.getData();
    },
    methods: {
        exportToExcel(type) {
            // 构建CSV数据
            var getCSVData = "";
            if(type == 1){
                 getCSVData = (data) => {
                const header = ['排名', '采购商', '进货额'];
                const rows = data.map((item, index) => [index + 1, item.name, item.amount]);
                return [header, ...rows].map(row => row.join(',')).join('\n');
                };
            }else  if(type == 2){
                 getCSVData = (data) => {
                const header = ['排名', '业务员', '邀请人数'];
                const rows = data.map((item, index) => [index + 1, item.name, item.invites]);
                return [header, ...rows].map(row => row.join(',')).join('\n');
                };
            }
          

            // 创建并下载CSV文件
            const downloadCSV = (data, filename) => {
            const blob = new Blob(['\ufeff' + data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
            URL.revokeObjectURL(link.href);
            };

            // 导出进货排行数据
          

            if(type == 1){
                const csvData = getCSVData(this.purchaseRanking);
                downloadCSV(csvData, '采购商进货排行榜.csv');
            }else  if(type == 2){
                const csvData = getCSVData(this.salesRanking);
                downloadCSV(csvData, '业务员邀请人排行榜.csv');
            }
          
      
            },
        getData(){
            let self = this;
            StatisticsApi.getUserStatic(self.form, true)
            .then(res => {
                self.statistics  = res.data
            })
            .catch(error => {});
        },
        search(){
            this.getData();
            this.getPurchaseRanking();
            this.getSalesInviteRanking()
            this.initBarChart();
            this.initBarChart();
            this.initPieChart();
            
        },
        getSupplys(){
            let self = this;
    
    
            Warehouse_managementApi.getSupply({}, true)
                .then(data => {
              
                self.supply = data.data.supply
           
                })
                .catch(error => {
                });
        },
      toggleSupplierDropdown() {
        this.showSupplierDropdown = !this.showSupplierDropdown;
      },
      selectSupplier(supplier) {
        this.selectedSupplier = supplier;
        this.showSupplierDropdown = false;
        this.form.supply_id = supplier.supply_id
      },
      getPurchaseRanking(){
        let self = this;
            StatisticsApi.getPurchaseRanking(self.form, true)
            .then(res => {
                self.purchaseRanking = res.data;
            })
            .catch(error => {});
      },
      getSalesInviteRanking(){
        let self = this;
            StatisticsApi.getSalesInviteRanking(self.form, true)
            .then(res => {
                self.salesRanking = res.data;
            })
            .catch(error => {});
      },
      initBarChart() {
        const chart = echarts.init(this.$refs.barChart);

        let self = this;
            StatisticsApi.getMonthlyUserTrend(self.form, true)
            .then(res => {

                chart.setOption( res.data);
            })
            .catch(error => {});
    
     
      },
      initPieChart() {
        const chart = echarts.init(this.$refs.pieChart);
        let self = this;
            StatisticsApi.getUserTypeDistribution(self.form, true)
            .then(res => {

                chart.setOption( res.data);
            })
            .catch(error => {});

      }
    }
  };
  </script>
  
  <style scoped>
  .bg-gray-50 {
    background-color: #F9FAFB;
  }
  input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }
  input[type="date"] {
    min-width: 150px;
  }
  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  </style>


// WEBPACK FOOTER //
// src/views/statistics/user/indexx.vue